export default __webpack_public_path__ + "static/media/lock.9b33360e.svg";